/**
 * English - Authentication translations
 */
export const auth = {
  login: {
    title: 'Sign In',
    subtitle: 'Welcome back! Please sign in to continue.',
    email: 'Email Address',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    noAccount: "Don't have an account?",
    createAccount: 'Create Account',
    invalidCredentials: 'Invalid email or password',
    accountLocked: 'Account is locked. Please contact support.',
    orContinueWith: 'Or continue with',
    google: 'Continue with Google',
    emailLockedNotice: 'This email is linked to your co-applicant invitation and cannot be changed.',
  },
  register: {
    title: 'Create Account',
    subtitle: 'Start your mortgage application journey',
    fullName: 'Legal Full Name',
    fullNamePlaceholder: 'Enter your full legal name',
    legalNameNotice: 'Please use your full legal name exactly as it appears on your official ID (cédula, passport, or birth certificate). Your name cannot be changed later and must match your documentation for your mortgage application to be approved.',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email Address',
    password: 'Password',
    passwordHint: 'Min. 8 characters with uppercase, lowercase, number, and special character',
    confirmPassword: 'Confirm Password',
    passwordMismatch: 'Passwords do not match',
    phone: 'Phone Number',
    preferredLanguage: 'Preferred Language',
    agreeToTerms: 'I agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    acceptTermsRequired: 'You must accept the Terms of Service and Privacy Policy',
    terms: 'I agree to the Terms of Service and Privacy Policy',
    createAccount: 'Create Account',
    creating: 'Creating account...',
    hasAccount: 'Already have an account?',
    signIn: 'Sign In',
    orContinueWith: 'Or continue with',
    passwordRequirements: 'Password must be at least 8 characters with uppercase, lowercase, and number',
    successTitle: 'Account Created!',
    successMessage: 'Your account has been created successfully. Please check your email to verify your account.',
    goToLogin: 'Go to Sign In',
    emailLockedNotice: 'This email address is set by your invitation and cannot be changed.',
    invitationSuccessMessage: 'Your account has been created. Sign in below to continue your co-application.',
    success: 'Account created successfully! Please check your email to verify.',
    checkYourEmail: 'Check your email',
    verificationSentTo: 'We sent a verification link to',
    clickVerificationLink: 'Click the link in the email to verify your account. You\'ll be signed in automatically — no need to come back to this page.',
    checkSpam: 'Don\'t see it? Check your spam or promotions folder.',
    resendEmail: 'Resend verification email',
    alreadyVerified: 'Already verified?',
  },
  forgotPassword: {
    title: 'Reset Password',
    subtitle: 'Enter your email to receive a reset link',
    email: 'Email Address',
    sendLink: 'Send Reset Link',
    sending: 'Sending...',
    backToLogin: 'Back to Login',
    emailSent: 'Password reset email sent. Please check your inbox.',
    instructions: 'Enter your email address and we will send you instructions to reset your password.',
  },
  verifyEmail: {
    title: 'Verify Your Email',
    subtitle: 'Please check your inbox for the verification link',
    verifying: 'Verifying your email...',
    success: 'Email verified successfully!',
    redirectDashboard: 'Taking you to your dashboard...',
    failed: 'Email verification failed',
    resend: 'Resend verification email',
    resending: 'Resending...',
    resent: 'Verification email resent',
    alreadyVerified: 'Your email is already verified!',
    alreadyVerifiedHint: 'You can log in to access your account.',
    errorInvalidToken: 'This verification link is no longer valid.',
  },
  twoFactor: {
    title: 'Two-Factor Authentication',
    subtitle: 'Enter the code from your authenticator app',
    code: 'Verification Code',
    verify: 'Verify',
    verifying: 'Verifying...',
    resend: 'Resend Code',
    useBackupCode: 'Use backup code',
  },
  tabGuard: {
      title: 'This application is open in another tab',
      description: 'To protect your data, only one tab can be active at a time. You can continue here or switch back to the other tab.',
      useHere: 'Use here instead',
      signOut: 'Sign out',
    },
} as const;